// import {
//   Box,
//   Button,
//   Stack,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
// } from "@mui/material";
// import React, { useState } from "react";
// import styles from "../../styles/pages/editors.module.scss";
// import assest from "../../json/assest";
// import { useQuery } from "react-query";
// // import { EditorUserDeatilsutation } from "@/api/functions/editor.api";
// import moment from "moment";
// import { Link } from "react-router-dom";
// import { concatHostAndImagePath } from "../../lib/functions/utils.lib";
// import PerfectScrollbar from "react-perfect-scrollbar";
// import "react-perfect-scrollbar/dist/css/styles.css";
// import Pagination from "../UtilitiesComponent/Pagination";
// import { EditorVIDEOMutation } from "../../api/functions/editor.api";
// import ApiLoader from "../Loaders/ApiLoader";
// import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";

// const EditorMoadlTable = (selectedId) => {
//   console.warn(
//     "🚀 ~ file: EditorMoadlTable.jsx:27 ~ EditorMoadlTable ~ selectedId:",
//     selectedId?.handleTriggreFetch
//   );
//   const [page, setPage] = useState(1);

//   const handleDataFromChild = (e) => {
//     setPage(e);
//     // Do something with the data received from the child component
//   };
//   const { data: VIDEOList, isLoading } = useQuery(
//     ["VIDEOList", selectedId?.selectedId, page],

//     async () => {
//       return EditorVIDEOMutation({
//         editor_id: selectedId?.selectedId,
//         page: page,
//       });
//     }
//   );
//   const [openModal, setOpenModal] = useState(false);
//   const [id, setId] = useState();

//   const onOpen = (id) => {
//     setId(id);
//     setOpenModal(true);
//   };
//   const onClose = () => {
//     setId();
//     setOpenModal(false);
//     selectedId?.handleTriggreFetch();
//   };

//   return (
//     <>
//       <Box className={styles.stickytable}>
//         <PerfectScrollbar className={styles.editortableperfectScroll}>
//           <Box className={styles.tableResponsive}>
//             <TableContainer>
//               <Table className={styles.editorMainTable} stickyHeader>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell className={styles.thEditorVsid}>VSID</TableCell>
//                     <TableCell className={styles.thEditorThumbnail}>
//                       Thumbnail
//                     </TableCell>
//                     <TableCell className={styles.thEditorTitle}>
//                       Title
//                     </TableCell>
//                     <TableCell className={styles.thEditorTags}>Tags</TableCell>
//                     <TableCell className={styles.thEditorPubsince}>
//                       Pending Publication since
//                     </TableCell>
//                     <TableCell className={styles.thEditorPubdate}>
//                       Publishing Date
//                     </TableCell>
//                     <TableCell align="center" className={styles.thEditorView}>
//                       View
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>
//                 {isLoading ? (
//                   <ApiLoader loading={isLoading} />
//                 ) : (
//                   <>{VIDEOList?.data?.length > 0 ? (
//                     <TableBody>
//                       {VIDEOList?.data.map((row) => (
//                         <>
//                           <TableRow
//                             className={`${row.type === "highlight"
//                               ? `${styles.trHighlight}`
//                               : null
//                               }`}
//                           >
//                             <TableCell
//                               scope="row"
//                               className={styles.thEditorVsid}
//                             >
//                               {row?.id}
//                             </TableCell>
//                             <TableCell
//                               sx={{ lineHeight: "0" }}
//                               className={styles.thEditorThumbnail}
//                             >
//                               <img
//                                 src={concatHostAndImagePath(row?.thumbnail)}
//                                 width={73}
//                                 height={46}
//                                 alt="image"
//                                 className={styles.thumImg}
//                               />
//                             </TableCell>
//                             <TableCell className={styles.thEditorTitle}>
//                               <Typography
//                                 variant="body1"
//                                 className={styles.tableTitle}
//                               >
//                                 {row?.title}
//                               </Typography>
//                             </TableCell>
//                             <TableCell className={styles.thEditorTags}>
//                               <Stack
//                                 direction={"row"}
//                                 alignItems={"center"}
//                                 className={styles.tagsGroup}
//                               >
//                                 <Button>{row?.video_meta?.tags}</Button>
//                               </Stack>
//                             </TableCell>

//                             <TableCell className={styles.thEditorPubsince}>
//                               <Typography variant="body2">
//                                 {moment(row?.video_meta?.copywrite_completed_at).format(
//                                   "MMMM Do YYYY"
//                                 )}
//                                 <br /> at{" "}
//                                 {moment(row?.video_meta?.copywrite_completed_at).format(
//                                   "h:mm:ss a"
//                                 )}
//                               </Typography>
//                             </TableCell>
//                             <TableCell className={styles.thEditorPubdate}>
//                               <Typography variant="body2">
//                                 {moment(row?.video_meta?.published_at).format(
//                                   "MMMM Do YYYY"
//                                 )}
//                                 <br /> at{" "}
//                                 {moment(row?.video_meta?.published_at).format(
//                                   "h:mm:ss a"
//                                 )}
//                               </Typography>
//                             </TableCell>
//                             <TableCell
//                               align="center"
//                               className={styles.tdEditorView}
//                             >
//                               {/* <Link to="/" className={styles.StyledeyeIcon}>
//                                 <img
//                                   src={assest.IconView}
//                                   width={16}
//                                   height={16}
//                                   alt="icon"
//                                 />
//                               </Link> */}

//                                           {/* <a
//                                   target="_blank"
//                                     href={`video/${row?.vsid}`}
//                                     className={styles.StyledeyeIcon}
//                                   >
//                                     <img
//                                       src={assest.IconView}
//                                       width={16}
//                                       height={16}
//                                       alt="icon"
//                                     />
//                                   </a> */}

// <img
//   style={{cursor:"pointer"}}
//     onClick={() => onOpen(row.vsid)}
//     src={assest.IconView}
//     width={16}
//     height={16}
//     alt="icon"
//   />
//                             </TableCell>
//                           </TableRow>
//                           <TableRow className={styles.blnkTd}>
//                             <TableCell colSpan={7}>{""}</TableCell>
//                           </TableRow>
//                         </>
//                       ))}
//                     </TableBody>
//                   ) : (
//                     <TableBody>
//                       <TableCell colSpan={7}>
//                         <Box
//                           className={`${styles.dateRangeNoresult} ${styles.emptyItem} ${styles.emptyeditorTable}`}
//                         >
//                           <Box className={styles.noFilter}>
//                             <figure>
//                               <img
//                                 src={assest.roundRing}
//                                 width={207}
//                                 height={210}
//                                 alt="icon"
//                               />
//                             </figure>
//                             <Typography variant="body1">
//                               No videos have been published by{" "} <span>John Martin</span> yet. Please check back later or refresh the page.
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </TableCell>
//                     </TableBody>
//                   )}</>
//                 )}
//               </Table>
//             </TableContainer>
//           </Box>
//           {VIDEOList?.data?.length > 0 && (
//             <Box className={styles.innerPagination}>
//               <Pagination
//                 lastpage={VIDEOList?.last_page}
//                 page={page}
//                 sendDataToParent={handleDataFromChild}
//               />
//             </Box>
//           )}
//         </PerfectScrollbar>

// <VideoPageFullModal
//           onClose={onClose}
//           open={openModal}
//           id={id}
//           aria-labelledby="modal-modal-title"
//           aria-describedby="modal-modal-description"
//           className="videoPageModal"
//         />

//       </Box>
//     </>
//   );
// };

// export default EditorMoadlTable;

// import {
//   Box,
//   Button,
//   Stack,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
// } from "@mui/material";
// import React, { useState } from "react";
// import styles from "../../styles/pages/editors.module.scss";
// import assest from "../../json/assest";
// // import Image from 'next/image'
// import { Link } from "react-router-dom";
// import { useQuery } from "react-query";
// import { QCVIDEOMutation } from "../../api/functions/qc.api";
// import moment from "moment";
// import { concatHostAndImagePath } from "../../lib/functions/utils.lib";
// import Pagination from "../UtilitiesComponent/Pagination";
// import styles1 from "../../styles/pages/editors.module.scss";
// import QcConfirmFilter from "../AllFilterRow/SubmittedPageFilter/QcConfirmFilter";

// const EditorMoadlTable = (props) => {
//   const [page, setPage] = useState(1);
//   const handleDataFromChild = (e) => {
//     setPage(e);
//     // Do something with the data received from the child component
//   };

//   const { data: VIDEOList, isLoading } = useQuery(
//     ["VIDEOList", props?.selectedId, page],

//     async () => {
//       return QCVIDEOMutation({
//         quality_team_id: props?.selectedId,
//         page: page,
//         manager_decision: 2,
//         quality_team_decision: 2,
//       });
//     }
//   );

import {
  Box,
  Button,
  Dialog,
  InputAdornment,
  Modal,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import EmptyTable from "../../components/EmptyTable/EmptyTable";
import Filter from "../../components/Filter/Filter";
import React, { useEffect, useState, useRef } from "react";
import styles from "../../styles/pages/editors.module.scss";
import styles1 from "../../styles/components/video.module.scss";
import assest from "../../json/assest";
// import Image from 'next/image'
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { QCVIDEOMutation } from "../../api/functions/qc.api";
import {
  concatHostAndImagePath,
  concatHostAndVideoPath,
} from "../../lib/functions/utils.lib";
import moment from "moment";

import Pagination from "../UtilitiesComponent/Pagination";
import ApiLoader from "../Loaders/ApiLoader";
import SubmittedPendingFilter from "../AllFilterRow/SubmittedPageFilter/SubmittedPendingFilter";
import SubmittedPendingFilterModal from "../FilterModal/SubmittedPendingFilterModal";

import FilterModal from "../FilterModal/FilterModal";
import QcwebsitewebsiteFilterModal from "../FilterModal/QcwebsitewebsiteFilterModal";
import QcConfirmFilter from "../AllFilterRow/SubmittedPageFilter/QcConfirmFilter";
import {
  setPage,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setMonth,
  setYear,
  setSubmitPlace,
  setUserId,
  setManagerId,
  setQualityTeamId,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
} from "../../redux-toolkit/slices/qc.confirm.approved.approved.slice";
import { useAppSelector } from "../../hooks/useAppSelector";
// import {
//   setAggrementWithAnotherCompany,
//   setDuplicates,
// } from "../../redux-toolkit/slices/qc.confirm.approved.approved.slice";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import QcrejectrejectFilterModal from "../FilterModal/QcrejectrejectFilterModal";
import QcWebsiteonlyRejectedFilterModal from "../FilterModal/QcWebsiteonlyRejectedFilterModal";
import NoResultTwo from "../NoResult/NoResultTwo";
import PaginationTwo from "../UtilitiesComponent/PaginationTwo";
import QcdenaiedwebsiteRejectdFilter from "../AllFilterRow/SubmittedPageFilter/QcdenaiedwebsiteRejectdFilter";

import magnifying from "../../../src/public/assets/images/icon-magnifying.svg";
import SearchOopsIcon from "../../public/assets/icons/SearchOopsIcon";
import QcdenaiedWebsiteonlyAprovvedFilter from "../AllFilterRow/SubmittedPageFilter/QcdenaiedWebsiteonlyAprovvedFilter";
import QcdenaiedRejectedWebsiteolyFilter from "../AllFilterRow/SubmittedPageFilter/QcdenaiedRejectedWebsiteolyFilter";
import QcConfirmApprovedApprovedFilter from "../AllFilterRow/SubmittedPageFilter/QcConfirmApprovedApprovedFilter";
import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";
import { EditorVIDEOMutation } from "../../api/functions/editor.api";
import EditorFilter from "../AllFilterRow/SubmittedPageFilter/EditorFilter";
import HlsPalyer from "../VideoPages/components/HlsPlayer";

import "plyr/dist/plyr.css"; // Import Plyr styles
import Plyr from "plyr";
import Hls from "hls.js";
import WatchVideoModal from "../VideoPages/pages/WatchVideoModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const EditorMoadlTable = (props) => {
  console.warn(
    "🚀 ~ file: EditorMoadlTable.jsx:119 ~ EditorMoadlTable ~ propsEditorMoadlTable:",
    props
  );
  const {
    // page,
    has_note,
    unreachable_submitter,
    hasMessage,
    month,
    year,
    submit_place,
    user_id,
    manager_id,
    quality_team_id,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
    search,
  } = useAppSelector((s) => s.qcConfirmApproveApproveSlice);

  const dispatch = useAppDispatch();

  const {
    filterRowProps,
    datas,
    handlePageChange,

    p,
    // handleClearFilterModal,
    hideFilter,
  } = props;
  const [page, setPage] = useState(1);
  const handleDataFromChild = (e) => {
    setPage(e);
    // Do something with the data received from the child component
  };
  const [searchValue, setSearchValue] = React.useState("");
  const handleInputChange = (event) => {
    let inputValue = event.target.value;
    setSearchValue(inputValue);
    if (!inputValue) {
      filtersReset();
    }
  };

  const {
    data: VIDEOList,
    isLoading,

    refetch: refetchAgain,
  } = useQuery(
    ["VIDEOList", props?.selectedId, page],

    async () => {
      return EditorVIDEOMutation({
        editor_id: props?.selectedId,
        search: searchValue,
        page: page,
        manager_id,

        // manager_decision: 1,
        // quality_team_decision: 1,

        has_note,
        unreachable_submitter,
        submit_place: submit_other_website,
        country: submit_place,
        hasMessage,
        // month,
        // year,
        user_id,
        person_who_filmed,
        aggrement_with_another_company,
        // from,
        // to,

        from: month || year ? getStartEndDateTwo(month, year).start_date : from,
        to: month || year ? getStartEndDateTwo(month, year).end_date : to,
      });
    }
  );
  console.warn(
    "🚀 ~ file: EditorMoadlTable.jsx:432 ~ EditorMoadlTable ~ VIDEOList:Editor",
    VIDEOList
  );
  const [fetchTrigger, setFetchTrigger] = useState(Date.now());

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };
  const handlePageChange2 = (p) => {
    setPage(p);
    handleTriggreFetch();
  };
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const filterRefetch = () => {
    refetchAgain();

    setOpenFilterModal(false);
  };

  const filtersReset = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setManagerId(null));
    setSearchValue("");
    dispatch(setHasMessage(null));

    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    handleTriggreFetch();
  };

  const handleClearFilterModal = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setManagerId(null));
    dispatch(setHasMessage(null));

    // dispatch(setDuplicates(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    handleTriggreFetch();
  };
  useEffect(() => {
    refetchAgain();
  }, [fetchTrigger]);

  const [filterActive, setFilterActive] = useState(false);

  useEffect(() => {
    if (
      // search ||
      has_note ||
      unreachable_submitter ||
      hasMessage ||
      month ||
      year ||
      submit_place ||
      user_id ||
      manager_id ||
      quality_team_id ||
      people_appearing ||
      person_who_filmed ||
      submit_other_website ||
      aggrement_with_another_company
    ) {
      setFilterActive(true);
    } else {
      setFilterActive(false);
    }
  }, [
    user_id,
    month,
    year,
    submit_place,
    // search,
    has_note,
    unreachable_submitter,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    quality_team_id,
    manager_id,
    hasMessage,
  ]);

  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    handleTriggreFetch();
  };

  const [videopopupModal, setVideopopupModal] = React.useState(false);
  const [videoId, setvideoId] = useState("");
  console.warn(
    "🚀 ~ file: EditorMoadlTable.jsx:595 ~ EditorMoadlTable ~ videoId:",
    videoId
  );
  const handleOpen = (event) => {
    console.warn(
      "🚀 ~ file: EditorMoadlTable.jsx:591 ~ handleOpen ~ event:",
      event
    );
    // return {};
    setvideoId(event);
    setVideopopupModal(true);
  };
  const handleClose = () => setVideopopupModal(false);

  const videoRef = useRef();

  // console.warn('source', source)

  function updateQuality(newQaulity) {
    window.hls.levels.forEach((level, levelIndex) => {
      if (level.height === newQaulity) {
        window.hls.currentLevel = levelIndex;
      }
    });
  }
  const handleContentLoaded = () => {
    // console.warn("call");
    var video = videoRef.current;
    // var source = source;

    const defaultOptions = {};

    if (Hls.isSupported()) {
      // console.warn("support");
      const hls = new Hls();
      hls.loadSource(videoId);
      hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
        const availableQualities = hls.levels.map((l) => l.height);
        defaultOptions.controls = [
          "play",
          "current-time",
          "progress",
          "duration",
          "fast-forward",
          "mute",
          "settings",
          "fullscreen",
        ];
        defaultOptions.quality = {
          default: availableQualities[0],
          options: availableQualities,
          forced: true,
          onChange: (e) => updateQuality(e),
        };
        new Plyr(video, defaultOptions);
      });
      hls.attachMedia(video);
      window.hls = hls;
    }
  };

  useEffect(() => {
    handleContentLoaded();
  }, []);

  const [openModalTwo, setOpenModalTwo] = useState(false);

  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  // const [first, setfirst] = useState(VIDEOList?.data?.data?.video_meta?.tags)
  //   const str = first ;
  //   const arr = str.split(",");
  //   console.warn("🚀 ~ file: EditorMoadlTable.jsx:680 ~ EditorMoadlTable ~ arr:sdasda", arr)

  return (
    <>
      <EditorFilter
        {...filterRowProps}
        filterActive={filterActive}
        VIDEOList={VIDEOList?.data}
        FilterModalComponent={QcWebsiteonlyRejectedFilterModal}
        filterModalProps={{
          searchValue,
          setSearchValue,
          openFilterModal,
          handleTriggreFetch,
          hideBottom: false,
          setOpenFilterModal,
          filterRefetch,
          filtersReset,
          handleClearFilterModal,
          handleInputChange,

          p,
          states: {
            // search,

            has_note,
            unreachable_submitter,
            hasMessage,
            month,
            year,
            submit_place,
            user_id,
            manager_id,
            quality_team_id,
            people_appearing,
            person_who_filmed,
            submit_other_website,
            aggrement_with_another_company,
            from,
            to,
          },
          setStates: {
            setHasNote,
            setUnreachableSubmitter,
            setHasMessage,
            setMonth,
            setYear,
            setSubmitPlace,
            setUserId,
            setManagerId,
            setQualityTeamId,
            setPeopleAppearing,
            setPersonWhoFilmed,
            setSubmitOtherWebsite,
            setAgreementWithAnotherCompany,
            setFrom,
            setTo,
          },
        }}
      />
      <Box className={`${styles.stickytable}`}>
        <Box className={`${styles.tableResponsive} ${styles.scrollRoot}`}>
          <TableContainer className={styles.editortableperfectScroll}>
            <Table className={styles.editorMainTable} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={styles.thEditorVsid}>VSID</TableCell>
                  <TableCell className={styles.thEditorThumbnail}>
                    Thumbnail
                  </TableCell>
                  <TableCell className={styles.thEditorTitle}>Title</TableCell>
                  <TableCell className={styles.thEditorTags}>Tags</TableCell>
                  <TableCell className={styles.thEditorPubsince}>
                    Pending Publication since
                  </TableCell>
                  <TableCell className={styles.thEditorPubdate}>
                    Publishing Date
                  </TableCell>
                  <TableCell align="center" className={styles.thEditorView}>
                    View
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <ApiLoader loading={isLoading} />
                ) : (
                  <>
                    {VIDEOList?.data?.data?.map((row) => (
                      <>
                        <TableRow
                          className={`${
                            row.type === "highlight"
                              ? `${styles.trHighlight}`
                              : null
                          }`}
                        >
                          <TableCell
                            scope="row"
                            className={styles.thEditorVsid}
                          >
                            {row?.id}
                          </TableCell>

                          <TableCell
                            sx={{ lineHeight: "0" }}
                            className={styles.thEditorThumbnail}
                          >
                            <Button
                              onClick={() => onOpenTwo(row.id)}
                              sx={{ padding: "0" }}
                            >
                              <img
                                src={concatHostAndImagePath(row?.thumbnail)}
                                width={73}
                                height={46}
                                alt="image"
                                className={styles.thumImg}
                              />
                            </Button>
                          </TableCell>

                          <TableCell className={styles.thEditorTitle}>
                            <Typography
                              variant="body1"
                              className={styles.tableTitle}
                            >
                              {row?.title}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.thEditorTags}>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              className={styles.tagsGroup}
                            >
                              <Button>{row?.video_meta?.tags}</Button>
                            </Stack>
                          </TableCell>

                          <TableCell className={styles.thEditorPubsince}>
                            <Typography variant="body2">
                              {moment(
                                row?.video_meta?.copywrite_completed_at
                              ).format("MMMM Do YYYY")}
                              <br /> at{" "}
                              {moment(
                                row?.video_meta?.copywrite_completed_at
                              ).format("h:mm:ss a")}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.thEditorPubdate}>
                            <Typography variant="body2">
                              {moment(row?.video_meta?.published_at).format(
                                "MMMM Do YYYY"
                              )}
                              <br /> at{" "}
                              {moment(row?.video_meta?.published_at).format(
                                "h:mm:ss a"
                              )}
                            </Typography>
                          </TableCell>
                          <TableCell
                            align="center"
                            className={styles.tdEditorView}
                          >
                            <img
                              style={{ cursor: "pointer" }}
                              onClick={() => onOpen(row.vsid)}
                              src={assest.IconView}
                              width={16}
                              height={16}
                              alt="icon"
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow className={styles.blnkTd}>
                          <TableCell colSpan={7}>{""}</TableCell>
                        </TableRow>
                      </>
                    ))}
                    {VIDEOList?.data?.data?.length > 0 ? (
                      <TableRow className={styles.nonHover}>
                        <TableCell colSpan={10}>
                          {VIDEOList?.data.data.length <
                            VIDEOList?.data?.per_page &&
                          VIDEOList?.data.last_page == 1 ? (
                            <>
                              <p className={styles.endListMsg}>
                                End of list. We couldn't find more videos
                                matching your selected filter(s).
                              </p>
                            </>
                          ) : (
                            <>
                              <PaginationTwo
                                page={page}
                                count={VIDEOList?.data?.last_page}
                                handleChange={handlePageChange2}
                              />
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow className={styles.nonHover}>
                        <TableCell colSpan={10}>
                          {filterActive ? (
                            <Filter resetFilters={filtersReset} />
                          ) : (
                            <>
                              {searchValue === "" ? (
                                <NoResultTwo heading="pending" />
                              ) : (
                                <Box
                                  className={`${styles.dateRangeNoresult} ${styles.emptyResult}`}
                                >
                                  <Box className={styles.noFilter}>
                                    <figure>
                                      <SearchOopsIcon />
                                    </figure>
                                    <Typography variant="body1">
                                      We couldn’t find any matching approved
                                      videos for
                                      <span>{props?.name}</span>.
                                    </Typography>
                                  </Box>
                                </Box>
                              )}
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )}

                <ApiLoader loading={isLoading} />
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* <Modal
          open={videopopupModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Text in a modal
            </Typography>
            
             
                       <Box
                      className={styles.videoBox}
                      // onClick={handleClickOpenProceed}
                       >
                   
                      <HlsPalyer
                        source={concatHostAndVideoPath(videoId)}
                      />
                    </Box>
          </Box>
        </Modal> */}

        <WatchVideoModal
          onClose={onCloseTwo}
          open={openModalTwo}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
        <VideoPageFullModal
          onClose={onClose}
          open={openModal}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
      </Box>

      <Dialog
        // fullScreen
        open={videopopupModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box className={styles1.videoWrapper}>
          <Box className={styles1.videoWrapperLeft}>
            <Box className="VideocommonBox">
              <Box className={styles1.videoSection}>
                <Box className={styles1.videoBox}>
                  {/* <HlsPalyer source={concatHostAndVideoPath(videoId)} /> */}

                  <video ref={videoRef}></video>
                  {/* <video src="http://techslides.com/demos/sample-videos/small.mp4" controls></video> */}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default EditorMoadlTable;
